import React, {
  useState, useEffect, useCallback, ReactElement,
} from 'react';

const useModal = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalFormState, setModalFormState] = useState({});
  const [modalData, setModalData] = useState<{
    onConfirmAsync?:(args?: any) => Promise<any>,
    onConfirm?: (args?: any) => any,
    onClose:(args?: any) => void|Promise<any>,
    onSuccess?:(args?: any) => void,
    title?: string,
    message: string|ReactElement,
    isSimple?: boolean,
    useSwal?: boolean,
    ModalForm?: React.FC<{formState?: any, chosenAction?: string}>,
      }>({
        onClose: () => {},
        onSuccess: () => {},
        message: '',
        ModalForm: () => (<></>),
      });

  useEffect(() => {
    if (!showModal && modalData?.message) {
      setShowModal(true);
    }
  }, [modalData, showModal]);

  const getModalFormState = useCallback(() => {
    return modalFormState;
  }, [modalFormState]);

  const reloadPage: () => void = useCallback(() => {
    setShowModal(false);
    window.location.reload();
  }, [setShowModal]);

  return {
    modalData,
    setModalData,
    showModal,
    setShowModal,
    modalFormState,
    setModalFormState,
    getModalFormState,
    reloadPage,
  };
};

export default useModal;
